<template>
  <v-container>
    <h3>Investments</h3>
    <Investments/>
  </v-container>
</template>

<script>

import Investments from '@/components/Gl/Investments/InvestmentsList.vue';

export default {
  name: 'Sai',
  components: {
    Investments,
  },
};
</script>
